// extracted by mini-css-extract-plugin
module.exports = {"container":"landing_container__2fryk","btn":"landing_btn__11l5d","title":"landing_title__30TdT"};